import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式} from '@/type/validation/validator';
import {渓仁会納品データ検索依頼型} from '@/type/custom/keijinkai/deliverydata';

export default class 渓仁会納品データ検索条件チェッカー {
  単項目チェック結果: Error[];
  相関チェック結果: Error[];

  constructor(target: 渓仁会納品データ検索依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
    const 納品日範囲エラー = 納品日範囲のFromがToより小(target);
    this.相関チェック結果 = 納品日範囲エラー;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '納品日FROM',
    constraints: [
      {method: 必須入力, message: '納品日（開始日付）は入力必須項目です'},
      {method: 日付書式, message: '納品日（開始日付）の書式を正しく入力してください'},
    ],
  },
  {
    name: '納品日TO',
    constraints: [
      {method: 日付書式, message: '納品日（開始日付）の書式を正しく入力してください'},
    ],
  },
];

function 納品日範囲のFromがToより小(target: 渓仁会納品データ検索依頼型): Error[] {
  const errors: Error[] = [];
  if (target.納品日FROM === null || target.納品日TO === null) {
    return errors;
  }
  if (target.納品日FROM.valueOf() > target.納品日TO.valueOf()) {
    errors.push({index: 0, message: '納品日の範囲指定が間違っています', constraint: '', name: '納品日範囲エラー'});
  }
  return errors;
}
